"use client"
import IconArrowUp from "@/app/(site)/_components/Atoms/Icons/IconArrowUp"
import Text from "@/app/(site)/_components/Atoms/Text"
import { getLangCode } from "@/app/(site)/_utils/misc"
import { t } from "@/translations"
import Logo from "@assets/LogoWhite.svg"
import { usePathname } from "next/navigation"
import { useCallback } from "react"
import BaseImage from "../../Atoms/BaseImage"

export default function BottomFooter() {
    const langCode = getLangCode(usePathname().split("/")[1]) ?? ""
    const scrollToTop = useCallback(() => {
        window.scrollTo({ top: 0, behavior: "smooth" })
    }, [])
    return (
        <div className="grid grid-cols-1 px-16 pb-16 md:grid-cols-3 md:px-24 md:pb-24">
            <div className="mb-64 flex flex-col items-start justify-start gap-3 text-main-white/80 md:mb-0 md:flex-row md:items-end">
                <Text size="extrasmall" weight="regular">
                    COPYRIGHT{" "}
                </Text>
                <Text size="extrasmall" weight="regular">
                    POC {new Date().getFullYear()}
                </Text>
            </div>
            <BaseImage
                className="m-auto"
                src={Logo.src}
                alt="POC Sports Logo"
                style={{ width: "90px", height: "30px" }} // Next image will complaing about
                width={90}
                height={30}
                quality={100}
                unoptimized
            />
            <div className="order-first my-64 flex cursor-pointer items-end justify-start gap-2 uppercase md:order-none md:my-0 md:mb-0 md:justify-end">
                <button
                    onClick={scrollToTop}
                    aria-label="Go to top of the page"
                    className="inline-flex items-center"
                >
                    <Text
                        size="extrasmall"
                        weight="regular"
                        className="inline-flex gap-5 text-white"
                    >
                        {t(langCode, "common.back_to_top")}{" "}
                        <IconArrowUp className="h-14 w-14" />
                    </Text>
                </button>
            </div>
        </div>
    )
}
